import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickApiTable from '@/components/brick_api_table.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-file', 'text-blue']
infos.front_classes = ['fas', 'far fa-brackets-curly', 'text-white']
infos.name = 'api_table'
infos.associated_class_name = 'AutomlApiTable'
infos.editing_component_name = 'BrickApiTable'
infos.editing_component = BrickApiTable
infos.summary_component_name = ''
infos.summary_component = undefined
infos.element_preview_type = ''
infos.descriptions = {
	en: {
		short_tooltip_description: 'API Table',
		full_tooltip_description: 'Create table from API data',
		navbar_name: 'API Table',
	},
	fr: {
		short_tooltip_description: 'Table API',
		full_tooltip_description: 'Création de table depuis les données API',
		navbar_name: 'Table API',
	},
}
// infos.short_tooltip_description = 'api_table_short_tooltip'
// infos.full_tooltip_description = 'api_table_full_tooltip'
// infos.navbar_name = 'api_table_navbar'
infos.background_color = 'blue'

brick_registerer(infos)
